import React from "react";
import { connect } from "react-redux";
import { Icon, Button } from "semantic-ui-react";
import { FacebookShareButton, TwitterShareButton, LinkedInShareButton } from "../SharingButtons";
import { clearIsJustPulished } from "../../actions/postActions";
import "./index.css";

export function PublishSuccessBanner({ animationClass, post, actions }) {
  const campaignName = "publish success";
  return (
    <div className={`published-successfuly-wrapper published-successfuly ${animationClass}`}>
      <Button onClick={actions.clearIsJustPulished} icon="remove" floated="right" size="big" />
      <div className="success-message-wrapper">
        <Icon name="checkmark" size="huge" />
      </div>
      <div className="-text-wrapper">
        <h2>Congratulations!</h2>
        <p>Your case has been published successfully.</p>
      </div>
      <div className="-buttons-wrapper">
        <p className="-paragraph">Share your case:</p>
        <div>
          <FacebookShareButton post={post} campaignName={campaignName} />
          <TwitterShareButton post={post} campaignName={campaignName} />
          <LinkedInShareButton post={post} campaignName={campaignName} />
        </div>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      clearIsJustPulished: () => dispatch(clearIsJustPulished()),
    },
  };
}

export default connect(null, mapDispatchToProps)(PublishSuccessBanner);



// WEBPACK FOOTER //
// ./src/components/PublishSuccessBanner/index.js